import type { TechnologySignal } from '../../domain/signal';
import { TechnologyChangesType } from '../../domain/signal';

import { signalService } from './signal';

const getTechnologySignalEventActionText = (type: TechnologyChangesType): string => {
  switch (type) {
    case TechnologyChangesType.RenewalComingUp:
      return 'has a potential renewal with';
    case TechnologyChangesType.Removed:
      return 'removed';
    default:
      return 'installed';
  }
};

export const getTechnologySignalEventText = (signal: TechnologySignal, companyName: string): string => {
  const { changeType, technologies, periodDays } = signal;

  if (changeType === TechnologyChangesType.Removed && !!periodDays) {
    return `${technologies[0]} was installed for ${signalService.getSignalEventPeriod(periodDays)}`;
  }

  return `${companyName} ${getTechnologySignalEventActionText(changeType)}`;
};

export const getTechnologiesListText = (technologies: string[]) => {
  if (technologies.length === 1) {
    return technologies[0];
  }

  return `${technologies.length} technologies`;
};
